module.exports = __webpack_public_path__ + "img/symbol_2.bea72a78.png";